export default "__VITE_ASSET__00961629__"